// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\events.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\events.tsx");
  import.meta.hot.lastModified = "1760464886205.697";
}
// REMIX HMR END

import React, { useState } from "react";
import { Link } from "@remix-run/react";
export const meta = () => {
  return [{
    title: "Events - Nomadics Studios"
  }, {
    name: "description",
    content: "Discover and join exciting events at Nomadics Studios. Connect with creative professionals and explore new opportunities."
  }];
};
const locations = ["All Locations", "Bali, Indonesia", "New York, Brooklyn", "Bangkok, Thailand", "Mexico", "Costa Rica", "Mumbai"];
const staticImage = "/event.png"; // Replace with your static image path

const eventsData = [{
  id: 1,
  date: "23",
  month: "JUL",
  time: "11:50 PM",
  name: "Test event",
  image: staticImage,
  slug: "test-event"
}, {
  id: 2,
  date: "28",
  month: "JUN",
  time: "12:30 AM",
  name: "Music event",
  image: "/bw (2).png",
  slug: "music-event"
}, {
  id: 3,
  date: "15",
  month: "AUG",
  time: "06:00 PM",
  name: "Art Workshop",
  image: "/bw (3).png",
  slug: "art-workshop"
}, {
  id: 4,
  date: "10",
  month: "SEP",
  time: "02:30 PM",
  name: "Photography Session",
  image: "/bw (4).png",
  slug: "photography-session"
}, {
  id: 5,
  date: "22",
  month: "SEP",
  time: "07:45 PM",
  name: "Film Screening",
  image: "/bw (5).png",
  slug: "film-screening"
}, {
  id: 6,
  date: "05",
  month: "OCT",
  time: "04:15 PM",
  name: "Creative Meetup",
  image: staticImage,
  slug: "creative-meetup"
}, {
  id: 7,
  date: "18",
  month: "OCT",
  time: "08:00 PM",
  name: "Design Conference",
  image: "/bw (1).png",
  slug: "design-conference"
}, {
  id: 8,
  date: "30",
  month: "OCT",
  time: "05:30 PM",
  name: "Studio Tour",
  image: "/bw (2).png",
  slug: "studio-tour"
}, {
  id: 9,
  date: "12",
  month: "NOV",
  time: "01:00 PM",
  name: "Networking Event",
  image: "/bw (3).png",
  slug: "networking-event"
}];
export default function Events() {
  _s();
  const [selectedLocation, setSelectedLocation] = useState("All Locations");

  // 3 rows, 3 columns each
  const eventRows = Array(3).fill(0).map((_, rowIdx) => <div key={rowIdx} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
        {Array(3).fill(0).map((_, colIdx) => {
      const eventIndex = rowIdx * 3 + colIdx;
      const event = eventsData[eventIndex];
      return <Link key={colIdx} to={`/events-details/${event.slug}`} className="group block bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] cursor-pointer">
                <div className="relative overflow-hidden">
                  <img src={event.image} alt={event.name} className="w-full h-40 object-cover transition-transform duration-500 group-hover:scale-110" onError={e => {
            e.currentTarget.src = staticImage;
          }} />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300"></div>
                </div>
                <div className="flex items-center gap-4 px-4 py-3 group-hover:bg-gray-50 transition-colors duration-300">
                  <div className="text-center min-w-[40px]">
                    <div className="text-lg font-bold text-black group-hover:text-black/80 transition-colors">
                      {event.date}
                    </div>
                    <div className="text-xs text-gray-500 group-hover:text-gray-600 transition-colors">
                      {event.month}
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="font-semibold text-black group-hover:text-black/90 transition-colors">
                      {event.name}
                    </div>
                    <div className="text-xs text-gray-500 group-hover:text-gray-600 transition-colors">
                      {event.time}
                    </div>
                  </div>
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </Link>;
    })}
      </div>);
  return <main className="bg-white min-h-screen pb-24">
      {/* Location Filter */}
      <div className="max-w-7xl mx-auto pt-8 px-4">
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            LOCATION
          </label>
          <div className="flex flex-wrap gap-3">
            {locations.map(loc => <button key={loc} className={`px-5 py-2 rounded-full border font-medium text-sm transition ${selectedLocation === loc ? "bg-black text-white" : "bg-white text-black border-black hover:bg-gray-100"}`} onClick={() => setSelectedLocation(loc)}>
                {loc}
              </button>)}
          </div>
        </div>
      </div>

      {/* Events Grid */}
      <div className="max-w-7xl mx-auto px-4">{eventRows}</div>
    </main>;
}
_s(Events, "acywcNSK/NNUZsxds9jv/KV7Xyc=");
_c = Events;
var _c;
$RefreshReg$(_c, "Events");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;